import { cn } from '@/helpers/utils';

type FloatingBlurItem = {
    top?: string;
    left?: string;
    width?: string;
    height?: string;
    className?: string;
};

type FloatingBlurProps = {
    items?: FloatingBlurItem[];
};

export default function FloatingBlur({ items }: FloatingBlurProps) {
    if (!items) return null;

    return (
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
            {items.map(({ top = 'auto', left = 'auto', width = 'auto', height = width, className }) => {
                return (
                    <div
                        className={cn('absolute rounded-[50%] bg-gradient-radial', className)}
                        key={`${top}-${left}-${className ?? ''}`}
                        style={{
                            top,
                            left,
                            width,
                            height,
                        }}
                    />
                );
            })}
        </div>
    );
}
